import { useState, useEffect } from 'react';
import Axios from 'axios';

// Matches the BASEURL and Xapi key used in ApiHandler.js
// const BASEURL = 'http://localhost/fitt-lab-studio-admin/api/';
const BASEURL = 'https://administrator.fittlabstudio.com/api/';
const XAPI_KEY = 'jwZryAdcrffggf867DnjhjhfRvsfhjs08032022';

const usePaymentGateway = () => {
  const [gatewaySettings, setGatewaySettings] = useState(null);
  const [gatewayLoading, setGatewayLoading] = useState(true);
  const [gatewayError, setGatewayError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchSettings = async () => {
      setGatewayLoading(true);
      setGatewayError(null);
      try {
        const response = await Axios.get(`${BASEURL}payment-gateway/settings`, {
          headers: {
            Xapi: XAPI_KEY,
            'Content-Type': 'application/json',
            'accept-language': 'en'
          }
        });

        if (cancelled) return;

        const res = response.data;
        // API response shape: { status: 200, data: { cashfree_payment: {...}, bizzbrain_payment: {...} } }
        const isSuccess = res?.success === true || res?.status === 200;

        console.log('[usePaymentGateway] raw response:', response);
        console.log('[usePaymentGateway] res:', res);
        console.log('[usePaymentGateway] res.data:', res?.data);
        console.log('[usePaymentGateway] isSuccess:', isSuccess);

        if (isSuccess && res?.data) {
          const parsed = res.data.data ?? res.data;
          console.log('[usePaymentGateway] parsed gatewaySettings:', parsed);
          console.log('[usePaymentGateway] cashfree enabled value:', parsed?.cashfree_payment?.enabled, typeof parsed?.cashfree_payment?.enabled);
          console.log('[usePaymentGateway] bizzbrain enabled value:', parsed?.bizzbrain_payment?.enabled, typeof parsed?.bizzbrain_payment?.enabled);
          setGatewaySettings(parsed);
        } else {
          setGatewayError(res?.message || 'Failed to load payment settings.');
        }
      } catch (err) {
        if (!cancelled) {
          setGatewayError('Failed to load payment settings. Please try again.');
        }
      } finally {
        if (!cancelled) setGatewayLoading(false);
      }
    };

    fetchSettings();

    return () => {
      cancelled = true;
    };
  }, []); // Fresh fetch on every mount — no caching

  const bizzbrainEnabled = !!(gatewaySettings?.bizzbrain_payment?.enabled == true || gatewaySettings?.bizzbrain_payment?.enabled === 1 || gatewaySettings?.bizzbrain_payment?.enabled === '1');
  const cashfreeEnabled = !!(gatewaySettings?.cashfree_payment?.enabled == true || gatewaySettings?.cashfree_payment?.enabled === 1 || gatewaySettings?.cashfree_payment?.enabled === '1');

  return {
    gatewayLoading,
    gatewayError,
    bothEnabled: bizzbrainEnabled && cashfreeEnabled,
    onlyBizzbrain: bizzbrainEnabled && !cashfreeEnabled,
    onlyCashfree: cashfreeEnabled && !bizzbrainEnabled,
    noneEnabled:
      !bizzbrainEnabled &&
      !cashfreeEnabled &&
      !gatewayLoading &&
      !gatewayError,
    bizzbrainConfig: gatewaySettings?.bizzbrain_payment ?? null,
    cashfreeConfig: gatewaySettings?.cashfree_payment ?? null
  };
};

export default usePaymentGateway;
